import InputImage from "@/Components/Input/InputImage";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const Images = () => {
  const { t } = useTranslation("", { keyPrefix: "settings_page" });
  const { control } = useFormContext();

  return (
    <Controller
      name="images"
      control={control}
      render={({ value: images, onChange }) => {
        const onDelete = (key: string, index: number) =>
          onChange({
            ...images,
            [key]: images[key].filter((_, i) => i !== index),
          });

        return (
          <>
            <InputImage
              label={t("uploadIcon")}
              multi={false}
              name="logo"
              onchange={(key, _images) => {
                onChange({ ...images, [key]: _images });
              }}
              onDelete={onDelete}
              images={images}
            />
            <InputImage
              label={t("uploadBgImage")}
              multi={false}
              name="backgroundImage"
              onchange={(key, _images) => {
                onChange({ ...images, [key]: _images });
              }}
              onDelete={onDelete}
              images={images}
            />

            <InputImage
              libraryParams={{ image_type: 1 }}
              showLibrary
              multi
              label={t("uploadSliderImage")}
              name="sliderImages"
              onchange={(key, _images) => {
                // if (newState.length > MAX_IMAGE_COUNT) {
                //   alert(
                //     t(`settings_page.colorTemplate`).replace(
                //       "{MAX_IMAGE_COUNT}",
                //       MAX_IMAGE_COUNT as unknown as string
                //     )
                //   );
                //   return;
                // }
                onChange({ ...images, [key]: [...images[key], ..._images] });
              }}
              onDelete={onDelete}
              ondragEnd={(key, _images) =>
                onChange({ ...images, [key]: _images })
              }
              images={images}
            />
          </>
        );
      }}
    />
  );
};

export default Images;
